import { cn } from '@/lib/utils';
import type { HTMLAttributes } from 'react';

/**
 * Shimmer skeleton block for pending content. CSS-only (no motion runtime),
 * reduced-motion aware via the .galexia-skeleton media query in globals.css.
 *
 * Usage:
 *   <Skeleton className="aspect-video w-full" />          // media placeholder
 *   <Skeleton className="h-4 w-2/3" />                    // text line
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden
      className={cn('galexia-skeleton rounded-lg', className)}
      {...props}
    />
  );
}
